<template>
  <div class="soar-container flex flex-col gap-y-4">
    <div class="w-full flex gap-x-4">
      <button @click="$router.back()">
        <faChevronLeft class="w-4 fill-primary" />
      </button>
      <h1
        class="flex-1 text-xl md:text-2xl text-primary font-medium border-b border-brand-gray-300"
      >
        {{ $t('updateUserProfileInfo') }}
      </h1>
    </div>

    <div class="w-full flex justify-center">
      <div class="rounded-md border border-brand-gray-300 p-2 w-full md:w-1/3">
        <Form
          class="flex flex-col gap-3"
          v-slot="{ resetForm }"
          @submit="(values) => onSubmit(values, resetForm)"
        >
          <div class="flex gap-4 flex-col">
            <Field
              :rules="requiredRule"
              name="dateOfBirth"
              v-slot="{ field, errors: errs, handleChange }"
            >
              <Datepicker
                :field="field"
                :errors="errs"
                :label="$t('DateOfBirth')"
                :default-value="field.value"
                input-class="ps-3 py-0.5"
                max-date="__now__"
                @on-change="(date) => handleChange(date)"
              >
              </Datepicker>
            </Field>
            <Field
              :rules="requiredRule"
              name="nationalityID"
              v-slot="{ field, errors: errs, handleChange }"
            >
              <Dropdown
                :field="field"
                :errors="errs"
                :label="$t('Nationality')"
                :options="countries"
                input-class="px-3 py-1.5"
                direction="flex-col"
                @on-selection="(item) => handleChange(+item?.code)"
              ></Dropdown>
            </Field>
            <Field :rules="requiredRule" name="identityNumber" v-slot="{ field, errors: errs }">
              <TextInput
                :field="field"
                :errors="errs"
                :label="$t('IdentityNumber')"
                mask="784-####-#######-#"
                input-class="px-3 py-1.5"
                label-class="w-full"
                direction="flex-col"
              />
            </Field>
          </div>
          <button
            class="text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
          >
            <div class="p-2 bg-primary rounded-s-md">
              <faDiskette class="w-4 fill-white"></faDiskette>
            </div>
            <span class="w-full text-center">
              {{ $t('Save') }}
            </span>
            <div class="p-0.5"></div>
          </button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script setup>
import faChevronLeft from '@/assets/icons/faChevronLeft.svg?component'
import faDiskette from '@/assets/icons/faDiskette.svg?component'
import Datepicker from '@/components/SimpleForm/Datepicker.vue'
import Dropdown from '@/components/SimpleForm/Dropdown.vue'
import TextInput from '@/components/SimpleForm/TextInput.vue'
import axiosInstance from '@/services'
import { useLookupsStore } from '@/stores/lookups'
import { notify } from 'notiwind'
import { Field, Form } from 'vee-validate'
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import { DateTime } from 'luxon'

const router = useRouter()
const i18n = useI18n()
const lookupsStore = useLookupsStore()

const countries = ref()

onMounted(async () => {
  countries.value = await lookupsStore.fetchLookup('/api/lookup/countries')
})

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}

const onSubmit = async (form) => {
  form.dateOfBirth = DateTime.fromFormat(form.dateOfBirth, 'dd/MM/yyyy').toFormat('MM/dd/yyyy')

  await axiosInstance.post('/api/userProfile/updateSubUser', form)

  notify(
    {
      group: 'success',
      title: i18n.t('changeUserSuccess')
    },
    6000
  )

  router.back()
}
</script>

<style lang="scss" scoped></style>
